var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPreviewIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5234 20C5.00044 20 0.523438 15.523 0.523438 10C0.523438 4.477 5.00044 0 10.5234 0C16.0464 0 20.5234 4.477 20.5234 10C20.5234 15.523 16.0464 20 10.5234 20ZM9.14544 6.415C9.08525 6.37485 9.01531 6.35177 8.94304 6.34822C8.87078 6.34467 8.79891 6.36079 8.73508 6.39486C8.67126 6.42893 8.61787 6.47967 8.5806 6.54168C8.54333 6.60369 8.52357 6.67465 8.52344 6.747V13.253C8.52357 13.3253 8.54333 13.3963 8.5806 13.4583C8.61787 13.5203 8.67126 13.5711 8.73508 13.6051C8.79891 13.6392 8.87078 13.6553 8.94304 13.6518C9.01531 13.6482 9.08525 13.6252 9.14544 13.585L14.0244 10.333C14.0793 10.2965 14.1243 10.247 14.1554 10.1889C14.1865 10.1308 14.2028 10.0659 14.2028 10C14.2028 9.93409 14.1865 9.86921 14.1554 9.81111C14.1243 9.75302 14.0793 9.70351 14.0244 9.667L9.14444 6.415H9.14544Z",
    fill: "#26ABE1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPreviewIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/previewIcon.ee608ba5.svg";
export { ForwardRef as ReactComponent };